module.exports = __webpack_public_path__ + "5cf5869865f50cca82ec0de033a86310.pdf";